function scroll(elemId) {
    elemId.scrollIntoView({ behavior: 'smooth' })
}

export default scroll
